// extracted by mini-css-extract-plugin
export default {"footer":"c-f_ca"};